export const Opacity = '_opacity';
export const OpacityRec = '_opacityRec';
export const OpacityPrefix = '_opacityPrefix';
export const OpacityPrefixRec = '_opacityPrefixRec';
